import App from './App.vue'
import router from './router'
import { antComponents } from './antd'
import { CommonComponents } from './use-common-components'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import { useDirectives, lazyPlugin, usePermissionPlugin, useModalDirectives } from './directives'
import { message } from 'ant-design-vue'
// Ant Design Vue 4：基础重置样式（与官方 dist/reset.css 一致；走 es 路径便于 Vite 解析）
import 'ant-design-vue/es/style/reset.css'
// 再导入主题样式（覆盖默认样式）
import '/@/styles/index.scss'
// 主图标集（Project id 4862329）：66 个业务图标，字体文件在 src/assets/fonts/
import '/@/styles/iconfont.css'
// 补充图标集（Project id 5010045）：5 个直播控制图标，仅用于 livestream.vue
// @font-face 中已通过 unicode-range 限定码位，不影响主图标集的字体渲染
// TODO: 长期建议将三套 iconfont 合并为一个项目（src/assets/iconfont/ 中还有 4989271 仅供航线编辑页使用）
import '/@/assets/font/iconfont.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import './utils/rem'
import './permission'
import VueCompareImage from 'vue3-compare-image'
import VueKonva from 'vue-konva'
import { installCanvasReadbackOptimization } from './utils/canvas-will-read-frequently'
import i18n from './i18n'
// import { hookScript } from './utils/hookAmap'
// hookScript()

// 全局配置 message 组件
message.config({
  top: '80px',
  duration: 2,
  maxCount: 3
})

// Ant Design Vue Table 等在 scroll.y 与布局同帧测量时会触发 Chromium 的
// 将回调推迟到下一帧可避免误报为未处理错误。
const OriginalResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor (callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer)
      })
    })
  }
}

// 页面启动后清理动态分片重试标记，便于后续版本切换时再次兜底刷新。
sessionStorage.removeItem('__dynamic_import_retry__')
installCanvasReadbackOptimization()

const app = createInstance(App)
app.use(i18n)
app.use(store, storeKey)
app.use(router)
app.use(CommonComponents)
app.use(antComponents)
app.use(useDirectives)
app.use(useModalDirectives)
app.use(lazyPlugin)
app.use(usePermissionPlugin)
app.use(VueCompareImage)
app.use(VueKonva)
// 忽略 ConfigProvider 传入 theme 时因多根节点导致的 Vue 警告（主题仍正常生效）
app.config.warnHandler = (msg, instance, trace) => {
  if (msg.includes('Extraneous non-props attributes') && msg.includes('theme')) return
  console.warn('[Vue warn]:', msg, trace)
}

app.mount('#demo-app')
